import { type ReactNode } from "react";

interface LandscapeLayoutProps {
  children: ReactNode;
  className?: string;
}

export function LandscapeLayout({ children, className = "" }: LandscapeLayoutProps) {
  return (
    <div
      className={`
      min-h-screen max-h-screen 
      min-w-[568px] w-full 
      overflow-hidden 
      flex flex-col 
      bg-gradient-to-b from-blue-900 to-indigo-900 
      text-white 
      ${className}
    `}
    >
      {children}
    </div>
  );
}

export default LandscapeLayout;
